import useDynamicForm from '@/components/DynamicForms/useDynamicForm'
import useDataSources from '@/components/DynamicForms/useDataSources'
import { computed, toRefs } from '@vue/composition-api'
import _chunk from 'lodash/chunk'
import { truncate } from '@shared/utils/string'

// ⚠️ TODO: We need to make `props` explicit,
// instaed of passing whole props of component
export default function useFormListNestedForm ({
  emit,
  props,
  customizeField = defaultCustomizeField,
  collection,
} = {}) {
  const { config, formValue, value } = toRefs(props)
  const path = computed(() => `${collection}.${props.index}`)

  const { addLocalSourceData } = useDataSources({ overrideLocalSources: true })
  addLocalSourceData('record', value)

  const questions = computed(() => Object.values(config.value.fields).map((q) => customizeField(q)))
  const template = _chunk(questions.value.map(q => q.questionId), 2)

  const { formId } = useDynamicForm({
    questions,
    template,
    formValue: props.nestedMode ? formValue : value,
    path: props.nestedMode ? path : undefined,
  })

  return {
    formId,
  }
}

function defaultCustomizeField (question) {
  return {
    placeholder: truncate(`Enter ${question.label}`, 26),
    questionId: question.key,
    dataKey: question.key,
    ...question,
  }
}
